import React, { useEffect } from 'react';
import resume from "../../assets/documents/Gaurav's Resume.pdf";
import { useHistory, useParams } from 'react-router-dom';

export default function Redirect() {
  const { intent } = useParams();
  const history = useHistory();

  const intentUrlMapper = {
    twitter: 'https://twitter.com/iamgrawal',
    linkedin: 'https://linkedin.com/in/iamgrawal',
    facebook: 'https://facebook.com/iamgrawal',
    email: 'mailto:iamgrawal@gmail.com',
    telegram: 'https://t.me/iamgrawal',
    whatsapp: 'https://wa.me/918860832914',
    github: 'https://github.com/iamgrawal',
    instagram: 'https://instagram.com/iamgrawal',
    links: 'https://linktr.ee/iamgrawal',
    resume: resume,
  };

  useEffect(() => {
    if (intentUrlMapper[intent]) {
      window.location = intentUrlMapper[intent];
    } else history.push('/');
  });

  return intentUrlMapper[intent] ? (
    <div className="main">
      {'Hold on, you are being redirected to the page.'}
      <br />
      {"if you aren't redirected, then click on this link: "}
      <a
        href={intentUrlMapper[intent]}
        target="_blank"
        rel="noopener noreferrer"
      >
        {intentUrlMapper[intent]}
      </a>
    </div>
  ) : null;
}
